const auth0Config = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN || 'your-domain.auth0.com',
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID || 'your-client-id',
  audience: import.meta.env.VITE_AUTH0_AUDIENCE || 'https://your-api',
  // Always the CURRENT origin, never a fixed VITE_APP_BASE_URL: each workspace
  // subdomain (see @aimsos/auth's subdomain.js) must get its own Auth0
  // callback, otherwise the SDK redirects back to a different subdomain than
  // the one the user is on and the app looks like it "bounces back to login".
  redirectUri: window.location.origin,
};

export default auth0Config;
